import React from 'react';
import { useRouter } from 'next/router';

import { setCookie } from '../../utils/cookieHandle';
import NotificationMenu from '../../components/TopNav/NotificationMenu';
import UserAccountMenu from '../../components/TopNav/UserAccountMenu';

export const eventsNavigation = {
    registration: {
        name: 'Registration',
        href: '/events/annual-conference/registration?refresh=1'
    },
    payment: {
        name: 'Payment',
        href: '/events/annual-conference/registration/payment'
    },
    payment: {
        name: 'Confirmation',
        href: '/events/annual-conference/registration/payment/confirmation'
    },
    dashboard: {
        name: 'Ticket Dashboard',
        href: '/members/annual-conference/dashboard'
    },
    cancel: {
        name: 'Cancel Tickets',
        href: '/members/annual-conference/dashboard/cancel'
    },
    agenda: {
        name: 'Agenda',
        href: '/events/annual-conference/agenda'
    },
    myAgenda: {
        name: 'My Agenda',
        href: '/events/annual-conference/my-agenda'
    }
};

export default function Navigation({ children }) {
    const router = useRouter();

    const onClickLogo = () => {
        router.push('https://kingdomadvisors.com/members');
    };

    const handleUserNavigation = (url) => {
        if (url === '/login') {
            setCookie('jwt-token', null);
            setCookie('jwt-refresh-token', null);
            router.push(url);
        }
    };

    return (
        <>
            <div className="flex flex-col flex-1 justify-between h-screen">
                <div className="sticky top-0 flex-shrink-0 flex h-16 bg-sta-400 shadow" style={{ zIndex: '1300' }}>
                    <div className="flex-1 px-4 flex justify-between bg-white">
                        <div className="flex items-center px-4 w-full h-full">
                            <img
                                src="/static/images/logo.png"
                                alt="Kingdom Advisor Logo"
                                width={250}
                                height={'auto'}
                                onClick={onClickLogo}
                                className='hidden sm:flex'
                            />
                        </div>
                        <div className="ml-4 flex items-center md:ml-6">
                            <UserAccountMenu />
                        </div>
                    </div>
                </div>
                <main className="flex-1">
                    {children}
                </main>
            </div>
        </>
    )
}
